/**
 * Public Next app for live chat widget & embed (subdomain in production).
 * Diatur lewat NEXT_PUBLIC_LIVECHAT_ORIGIN (Doppler); bawaannya domain produksi.
 */
export const LIVECHAT_PUBLIC_ORIGIN =
  process.env.NEXT_PUBLIC_LIVECHAT_ORIGIN ?? "https://livechat.kustomersuite.com";
